import {
    CircleCheckIcon,
    InfoIcon,
    Loader2Icon,
    OctagonXIcon,
    TriangleAlertIcon,
} from "@/lib/eagerIcons"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ theme = "system", ...props }: ToasterProps) => {
    return (
        <Sonner
            theme={theme}
            className="toaster group"
            icons={{
                success: <CircleCheckIcon className="size-4" />,
                info: <InfoIcon className="size-4" />,
                warning: <TriangleAlertIcon className="size-4" />,
                error: <OctagonXIcon className="size-4" />,
                loading: <Loader2Icon className="size-4 animate-spin" />,
            }}
            style={
                {
                    // r106 D26: toasts ride the overlay MATERIAL (design language C6). The SAME recipe as
                    // `--color-material-popover` (`@theme inline` inlines that token at build time, so it is not a
                    // runtime variable to reference here); solid wherever `--material-opacity` is 100% (B2). The
                    // blur is `material-blur` on the toast class (ToasterReactComponent). Guard:
                    // overlayMaterials.contract.spec.ts.
                    "--normal-bg": "color-mix(in srgb, var(--popover) var(--material-opacity), transparent)",
                    "--normal-text": "var(--popover-foreground)",
                    "--normal-border": "var(--border)",
                    "--border-radius": "var(--radius)",
                    zIndex: "var(--z-layer-top)",
                    pointerEvents: "auto",
                } as React.CSSProperties
            }
            {...props}
        />
    )
}

export { Toaster }
